import { Component, EventEmitter, Injectable, Input, Output } from "@angular/core";
import { ProcessSummaryModel } from "../model/process-summary.model";
import { Router } from "@angular/router";
import { ProcessService } from "../service/process.service";
import { InstanceService } from "../service/instance.service";
import swal from "sweetalert2";
import { AttributeService } from "./dynamic/service/attribute.service";
import { AttributeModel } from "./dynamic/model/attribute.model";
import { ProcessModel } from "../model/process.model";
import { NgxSpinnerService } from "ngx-spinner";
import { SecurityService } from "../service/security.service";
import { AuthenticationService } from "../service/auth.service";
import { OptionModel } from "./dynamic/model/option.model";
import { InstanceModel } from "../model/instance.model";
import { PolicyModel } from "../model/policy.model";
import { PolicyService } from "../service/policy.service";
import { MaskApplierService } from "ngx-mask";
import { CurrencyService } from "../service/currency.service";

@Component({
    template: ''
})
export abstract class SummaryBase {

    @Input()
    process: ProcessSummaryModel
    @Output() onUpdatedItem: EventEmitter<any> = new EventEmitter()
    @Output() onRunningTask: EventEmitter<any> = new EventEmitter()
    @Output() onShowModalPrint: EventEmitter<any> = new EventEmitter()

    currentStep: InstanceModel;
    count: number = 0;

    linkView: InstanceModel;

    constructor(
        private attrService: AttributeService,
        private processService: ProcessService,
        private instanceService: InstanceService,
        private router: Router,
        private spinner: NgxSpinnerService,
        private securityService: SecurityService,
        private authService: AuthenticationService,
        private maskService: MaskApplierService,
        private currencyService: CurrencyService) { }

    get hasActions(): boolean {
        return this.getLinks().length > 0;
    }
    
    get hasViewLink(): boolean {
        return this.process.actions.some(attr => 
            attr.value &&
            attr.value.toLowerCase() == "view" && 
            attr.type.toLowerCase() == "link")
    }

    get isNewVersion(): boolean {
        return this.authService.getFrontendVersion() == "v2"
    }

    getClassName(): string {
        if (this.process.status && this.process.status.options) {
            let options = this.process.status.options

            if (options) {
                let classOpt = options.find(o => o.key.toLowerCase() == "class")

                if (classOpt && classOpt.value) {
                    return classOpt.value
                }
            }
        }

        return "process-create"
    }

    getOptionClassName(attribute: AttributeModel): string {
        let classOpt = attribute.options.find(o => o.key.toLowerCase() == "class")

        if (classOpt && classOpt.value) {
            return classOpt.value
        }

        return ""
    }

    chooseMode(linkAttr: AttributeModel) {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').removeClass('fade');
        $('.modal-backdrop').removeClass('show');
        $('.modal-backdrop').removeClass('modal-backdrop');

        if (linkAttr.value == 'edit') {
            this.navigateToProcess(this.process.id, linkAttr.value);
        }
        else if (linkAttr.value == 'edit-reopen') {
            swal.fire({
                title: 'Atenção',
                text: "Deseja reabrir o cadastro?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim'
              }).then((result) => {
                if (result.value) {
                  this.reopenProcess();
                }
              })
        } else if (linkAttr.value == 'view') {
            this.router.navigateByUrl('/processes/scope/' + linkAttr.value + '/' +
                this.process.policyId + '/' + this.process.id)
        } else if (linkAttr.value == 'duplicate') {
            swal.fire({
                title: 'Atenção',
                text: "Deseja duplicar o cadastro?",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Não',
                confirmButtonText: 'Sim'
              }).then((result) => {
                if (result.value) {
                  this.duplicateProcess();
                }
              })
        } else if (linkAttr.value && linkAttr.value.startsWith("http")) {
            this.accessLink(linkAttr);
        } else if (linkAttr.options.some(opt =>
            opt.key.toLowerCase() == "actiontype" &&
            opt.value.toLowerCase() == "turn")) {
                this.spinner.show();
                this.onRunningTask.emit()
                this.instanceService
                    .setCurrentStep(this.process.id, linkAttr.value)
                    .subscribe(() => {
                        this.onUpdatedItem.emit()
                    }, (error) => this.handleHttpError(error))
        } else if (linkAttr.value && linkAttr.value.startsWith("print")) {
            this.onShowModalPrint.emit(this.process.id);
        }
    }

    private accessLink(linkAttr: AttributeModel) {
        let accessCodeRule = linkAttr.options.find(opt =>
            opt.key.toLowerCase() == "AccessCodeRule".toLowerCase());

        if(accessCodeRule) {
            this.navigateByRule(accessCodeRule, linkAttr);
        } else {
            window.open(linkAttr.value, '_blank');
        }
    }

    private navigateByRule(accessCodeRule: OptionModel, linkAttr: AttributeModel) {
        if (accessCodeRule.value.toLowerCase() == "Replace Last Segment With New Access Code".toLowerCase()) {
            let url = new URL(linkAttr.value)
            let segments = url.pathname.split('/');
            let accessCode = segments.pop() || segments.pop();
            let loggedUserName = this.authService.getUser().userName;
            this.securityService.createUserAccess(accessCode, loggedUserName)
                .subscribe((access) => {
                    if (access) {
                        let newAccesCode = access.newAccessCode;
                        let newPath = segments.join("/")
                        newPath += `/${newAccesCode}`
                        window.open(`${url.origin}${newPath}`, '_blank');
                    }
                }, (error) => this.handleHttpError(error));
        }
    }

    private reopenProcess() {
        this.instanceService
            .setCurrentStep(this.process.id, "Start")
            .subscribe(() => {
                this.instanceService
                    .saveCurrentState(this.process.id)
                    .subscribe(() => {
                        this.processService
                            .saveCurrentState(this.process.id)
                            .subscribe(() => this.navigateToProcess(this.process.id, "edit"))
                    })
            })
    }

    private duplicateProcess() {
        this.spinner.show();
        this.instanceService
            .duplicate(this.process.id)
            .subscribe(
                (newProcess: ProcessModel) => {
                    this.spinner.hide()
                    this.navigateToProcess(newProcess.id, "edit")
                }, (error) => {
                    this.spinner.hide()
                    swal.fire("Atenção", error.message, "error")
                })
    }

    private navigateToProcess(processId: string, mode: string) {
        this.router.navigateByUrl('/processes/process/' +
            mode + '/' +
            this.process.policyId + '/' +
            processId);
    }

    public getItemTesteVictor()  {
          console.log(this.getItemBy(1));
    }

    getItemValue(index: number): string {
        let item = this.getItemBy(index)

        if (item && item.value) {
            const maskOpt = item.options
                .find(opt => opt.key.toLowerCase() == "mask");
            
            if(maskOpt?.value == "separator.2" || maskOpt?.value == "currency") {
                return this.currencyService.formatCurrencyValue(item.value);
            } else if(maskOpt?.value?.toLowerCase() == "document") {
                const docMask = this.getDocumentMask(item);
                return this.maskService.applyMask(item.value, docMask);
            } else if(maskOpt?.value.toLowerCase() == "date" ||
                      maskOpt?.value.toLowerCase() == "date br") {
                const date = new Date(item.value);
                return this.formatDateToBR(date);
            } else if(maskOpt?.value.toLowerCase() == "datetime" ||
                      maskOpt?.value.toLowerCase() == "datetime br") {
                const date = new Date(item.value);
                return this.formatDateTimeToBR(date);
            } else {
                return item.value
            }
        }
        else
         return null;
    }

    protected getDocumentMask(attribute: AttributeModel): string {
        if(attribute.value && attribute.value.length > 11) {
            return "00.000.000/0000-00"
        } else {
            return "000.000.000-00**"
        }
    }

    protected formatDateToBR(date: Date): string {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
      
        return `${day}/${month}/${year}`;
    }

    protected formatDateTimeToBR(dateTime: Date): string {
        const day = dateTime.getDate().toString().padStart(2, '0');
        const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
        const year = dateTime.getFullYear();
        const hours = dateTime.getHours().toString().padStart(2, '0');
        const minutes = dateTime.getMinutes().toString().padStart(2, '0');
        const seconds = dateTime.getSeconds().toString().padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    getItemKey(index: number, sufix?: string): string {
        let attribute = this.getItemBy(index)

        if (!sufix) {
            sufix = ''
        }

        if (attribute) {
            return `${this.getAttributeTitle(attribute)}${sufix} `
        }
    }

    private getAttributeTitle(attribute: AttributeModel): string {
        let titleOpt = attribute.options
            .find(opt => opt.key.toLowerCase() == "title")

        if(titleOpt) {
            return titleOpt.value
        }

        return attribute.key
    }

    getItemKeyAttribute(index: number, sufix?: string): AttributeModel {
      let item = this.getItemBy(index)

      if (!sufix) {
          sufix = ''
      }

      if (item) {
          return item
      }
  }

    private getItemBy(index: number): AttributeModel {
        return this.process.attributes.find(attr => {
            return this.attrService.hasOption(attr, "index", index)
        })
    }

    getLinks(): AttributeModel[] {
        if(this.process.instanceAttributes) {
            return this.process.instanceAttributes.filter(attr => attr.type.toLowerCase() == "link")
            
        } else if(this.process.actions) {
            return this.process.actions.filter(attr => attr.type.toLowerCase() == "link")
        }

        return 
    }

    getLinkView() {
        let viewAttribute = this.process.actions.find(attr => 
            attr.value &&
            attr.value.toLowerCase() == "view" && 
            attr.type.toLowerCase() == "link")

        if(viewAttribute) {
            this.router.navigateByUrl('/processes/scope/' + viewAttribute.value + '/' +
                this.process.policyId + '/' + this.process.id) 
        }
    }
    
    getStatus(): string {
        if (this.process.status) {
            return this.process.status.value
        }
    }

    private handleHttpError(error: any) {
        this.spinner.hide();

        if(error.status == 401) {
            this.authService.logout()
            this.router.navigate(['login']);
        } else if(error.status == 403) {
            swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
            .then(() => this.router.navigate([""]).then(() => swal.close()))
        } else if(error.message) {
            swal.fire("Atenção", error.message, "error").then(() => {
            this.onUpdatedItem.emit()
            if(error.goBackToHome) {
                this.router.navigate([""]).then(() => swal.close())
            }
            })
        } else {
            swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error").then(() => { this.onUpdatedItem.emit() })
        }
    }

    getCurrentStepName(): string {
        return this.process.status.value
    }

    getFirstTask(): string {
        let notificationTask = this.process.actions.find(attr => attr.type.toLowerCase() == "task" && 
            !attr.options.some(opt => opt.key.toLowerCase() == "Show Task Notification" &&
                                      opt.value.toLowerCase() == "false"))

        if(notificationTask) {
            return this.getTaskTitle(notificationTask)
        }

        return "Verificar"
    }

    private getTaskTitle(task: AttributeModel): string {
        let titleOpt = task.options.find(opt => opt.key.toLowerCase() == "title")

        if(titleOpt) {
            return titleOpt.value
        } else {
            return task.key
        }
    }

    getStepOptionByKey(key: string): string {
        if(key && this.process.status) {
            const statusOpt = this.process.status.options.find(opt => opt.key.toLowerCase() == key.toLowerCase());

            if(statusOpt) {
                return statusOpt.value;
            }
        }

        return null;
    }
}